<template>
    <AppHead title="Upgrade | 10xTravel Plus" />
    <div class="relative overflow-hidden">
        <UpgradeHero @checkout="goToCheckout" />
        <UpgradeFeatureGrid />
        <UpgradeCommunity />
        <UpgradeAwardAlerts />
        <UpgradeTestimonials />
        <UpgradePricing v-model:isYearlyBilling="isYearlyBilling" @checkout="goToCheckout" />
        <UpgradeFaq />
        <UpgradeCta @checkout="goToCheckout" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { router } from '@inertiajs/vue3';
import AppHead from '@/Partials/AppHead.vue';
import UpgradeHero from './Upgrade/UpgradeHero.vue';
import UpgradeFeatureGrid from './Upgrade/UpgradeFeatureGrid.vue';
import UpgradeCommunity from './Upgrade/UpgradeCommunity.vue';
import UpgradeAwardAlerts from './Upgrade/UpgradeAwardAlerts.vue';
import UpgradeTestimonials from './Upgrade/UpgradeTestimonials.vue';
import UpgradePricing from './Upgrade/UpgradePricing.vue';
import UpgradeFaq from './Upgrade/UpgradeFaq.vue';
import UpgradeCta from './Upgrade/UpgradeCta.vue';

const isYearlyBilling = ref(true);

onMounted(() => {
    const params = new URLSearchParams(window.location.search);
    const billing = params.get('billing');
    if (billing === 'monthly') {
        isYearlyBilling.value = false;
    } else if (billing === 'yearly') {
        isYearlyBilling.value = true;
    }
});

const goToCheckout = () => {
    router.visit(
        `/checkout?billing=${isYearlyBilling.value ? 'year' : 'month'}`
    );
};
</script>
